import { IProject } from '../interfaces/Project';

export const AbTradeData: IProject = {
  description: {
    title: 'ООО "АБСОЛЮТ-ТРЕЙД" Москва',
    titleDetailed: `Является дочерней компанией ООО "Кабельный Завод "ЭКСПЕРТ-КАБЕЛЬ".
    Ведущий  middle программист бэкенд node.js, nest.js. Удаленная работа.`,
    titleUrl: 'ab-trade.ru', // expert-cable.ru
    imgSrc: 'images/abtrade.png',
    imgAlt: 'abtrade logo',
    href: 'https://ab-trade.ru',
    role: 'Back-end',
    interval: 'Март 2023 — Июнь 2025 (2 года 3 месяца).',
    text: '',
  },
  mainFunctions: {
    functions: [
      'Разработка SRM-системы взаимодействия между покупателями и продавцами торговой площадки компании.',
      'Разработал архитектуру проекта',
      'Создал MVP',
      'Выполнял рефакторинг в связи с изменениями требований',
      'Интегрировал проект в другой продукт компании',
      'Участвовал в собеседованиях специалистов своего профиля',
      'Взаимодействовал с другими сотрудниками компании, включая менеджеров проектов, backend- и frontend-разработчиков',
      'Работал с системами трекинга задач: Bitrix24, Jira',
    ],
  },
  mainTechnologies: [
    'TypeScript',
    'Nodejs, Nestjs',
    'PostgreSQL, TypeORM',
    'RabbitMQ',
    'Redis',
    'Docker',
    'Swagger, REST API',
    'Git',
    'eslint, prettier',
  ],
};
